export default "__VITE_ASSET__4pEQmaIh__"